import React from "react";
import "./styles.css";
import TileArrow from "../../assets/images/TileArrow.png";
import { useNavigate } from "react-router-dom";
const Tile = ({ image, text, number, arrow, to }) => {
  const navigate = useNavigate();

  const HandleClick = () => {
    navigate(to);
  };
  return (
    <>
      <div
        onClick={HandleClick}
        style={{ cursor: "pointer" }}
        className="mainTile"
      >
        <div className="contentDiv">
          <div className="imageDiv">
            <img src={image} alt="Student Here"></img>
          </div>
          <div style={{ cursor: "pointer" }} className="textDiv">
            <div className="UpperText">
              {/* <h2>{number === undefined || number === null ? 0 : number}</h2> */}
              <h2>{number >= 0 ? number : 0}</h2>
            </div>
            <div className="lowerText">{text}</div>
          </div>

          <div className="arrowDiv">
            <img src={TileArrow} alt="arrow" />
          </div>
        </div>
      </div>
    </>
  );
};
export default Tile;
